import { Redirect, useLocalSearchParams } from 'expo-router';

const getParamValue = (value: string | string[] | undefined) =>
  Array.isArray(value) ? value[0] || '' : value || '';

export default function JoinSessionIndexRoute() {
  const { code, host, mode, guest } = useLocalSearchParams<{
    code?: string | string[];
    host?: string | string[];
    mode?: string | string[];
    guest?: string | string[];
  }>();
  const inviteCode = getParamValue(code).trim();

  if (!inviteCode) {
    return <Redirect href="/" />;
  }

  return (
    <Redirect
      href={{
        pathname: '/',
        params: {
          code: inviteCode,
          host: getParamValue(host).trim(),
          mode: getParamValue(mode).trim(),
          guest: getParamValue(guest).trim(),
          autoJoin: '1',
          autojoin: '1',
        },
      }}
    />
  );
}
